var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { crossSvg, menuSvg, searchSvg } from '../../helpers/elements.js';
import { getLanguageCode } from '../../i18n.js';
import { resolveDeployPrefix } from '../../initialization/deployPrefixResolver.js';
import '../components/element-button.js';
import { classMap } from 'lit/directives/class-map.js';
import './element-b2b-menu.js';
import './element-b2b-search.js';
const deployPrefix = resolveDeployPrefix();
let B2bElementHeader = class B2bElementHeader extends LitElement {
    constructor() {
        super();
        this.searchActive = false;
        this.menuOpened = false;
        this.redBackground = false;
    }
    async connectedCallback() {
        super.connectedCallback();
    }
    renderSearch() {
        return html `<element-b2b-search
      class="flex"
      @close="${() => (this.searchActive = false)}"
    ></element-b2b-search>`;
    }
    renderHeader() {
        const languageCode = getLanguageCode();
        const iconClasses = `w-header-icon-s md:w-header-icon-m xxl:w-header-icon-l mx-[12px] my-[8px] ${this.redBackground
            ? 'fill-white group-hover:fill-chm-focus-white'
            : 'fill-black group-hover:fill-chm-focus-red'}`;
        const whitePrefix = this.redBackground ? 'w_' : '';
        return html `
      <div class="flex transition duration-300 justify-center h-header-zero md:h-header-sm xxl:h-header-mdxx shadow-header ${classMap({
            'bg-white': !this.redBackground,
            'bg-chm-red': this.redBackground,
        })}">
        <div id='headerDiv' class="flex items-center justify-between w-content  md:gap-x-[32px] xxl:gap-x-[40px]">
          <a href="/${languageCode}"
            @click=${() => {
            this.menuOpened = false;
            this.redBackground = false;
        }}
            class="min-w-logo-chm-s sm:min-w-logo-chm-m mdxx:min-w-logo-chm-l">
            <img class="hidden md:block h-[54px] xxl:h-[65px] w-auto aspect-[209/27] xxl:aspect-[503/65]"
                 src="${deployPrefix}/img/logo_b2b/${whitePrefix}sm_b2b_logo_${languageCode}.svg?ts11=TIMESTAMP11" alt="SchweizMobil">
            <img class="block md:hidden h-[38px] aspect-[97/38]"
                 src="${deployPrefix}/img/logo_b2b/${whitePrefix}s_sm_b2b_logo.svg?ts11=TIMESTAMP11"
                 alt="logo" width="97" height="38">
          </a>
          <div class="flex items-center gap-x-[2px] md:gap-x-[32px] xxl:gap-x-[40px]">
          <button class="group rounded-lg transition-all duration-300 ${classMap({ 'hover:bg-chm-focus-red': this.redBackground })}" @click="${() => {
            this.searchActive = true;
            this.menuOpened = false;
            this.redBackground = false;
        }}" aria-label="Suchen...">
            ${searchSvg(iconClasses)}
          </button>
          <button class="flex group items-center rounded-lg hover:bg-white justify-center ${classMap({ hidden: this.menuOpened })}"
                  @click=${() => {
            this.menuOpened = !this.menuOpened;
            this.redBackground = !this.redBackground;
        }}
                  aria-label="Men\u00FC">
            <span class="font-bold hidden md:block ml-[12px] group-hover:text-chm-focus-red ${classMap({ 'text-white': this.redBackground })}">Men\u00FC</span>
            ${menuSvg(iconClasses)}
          </button>
          <button class="flex group transition duration-300 items-center rounded-lg hover:bg-chm-focus-red justify-center ${classMap({ hidden: !this.menuOpened })}"
                  @click=${() => {
            this.menuOpened = !this.menuOpened;
            this.redBackground = !this.redBackground;
        }}
                  aria-label="Men\u00FC schliessen">
            ${crossSvg(iconClasses)}
          </button>
          </div>
          </div>
        </div>
        <element-b2b-menu
          @closeMenu=${() => {
            this.menuOpened = !this.menuOpened;
            this.redBackground = !this.redBackground;
        }}
         class="${classMap({ 'hide-menu': !this.menuOpened, 'show-menu': this.menuOpened })} transition-[opacity,visibility] ease-in-out duration-300 absolute w-screen top-header-zero md:top-header-sm xxl:top-header-mdxx z-[40]"></element-b2b-menu>
      </div>
    `;
    }
    render() {
        return this.searchActive ? this.renderSearch() : this.renderHeader();
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    state()
], B2bElementHeader.prototype, "searchActive", void 0);
__decorate([
    state()
], B2bElementHeader.prototype, "menuOpened", void 0);
__decorate([
    state()
], B2bElementHeader.prototype, "redBackground", void 0);
B2bElementHeader = __decorate([
    customElement('b2b-element-header')
], B2bElementHeader);
export { B2bElementHeader };
//# sourceMappingURL=b2b-element-header.js.map